import restartSVG from '../../images/restart.svg';

const ResetButton = ({ onClick, inline }) => {
  return (
    <div className={`d-flex align-items-center ${inline ? '' : 'w-100 justify-content-end'}`}>
      <div className="d-flex">
        <button className="reset-btn-filters invoice-add-btn red-text" onClick={onClick}>
          <span
            className="text-decoration-underline "
            style={{ fontWeight: '600', fontSize: '0.9rem', padding: '0.2' }}
          >
            Reset Filters
          </span>
          <img style={{ color: 'blue' }} src={restartSVG} width="20" alt="" />
        </button>
      </div>
    </div>
  );
};

export default ResetButton;
